import React from 'react'




const Section3 = () => {

    const kols = [
        {
            title:"陳零九", 
            url:"https://www.facebook.com/09chen09", img:"pic_01.png"
        },
        {
            title:"黃偉晉", 
            url:"https://www.facebook.com/officialwaynehuang", img:"pic_02.png"
        },
        {
            title:"六嘆", 
            url:"https://www.twitch.tv/sixwong", img:"pic_03.png"
        },
        {
            title:"小葵", 
            url:"https://www.youtube.com/channel/UCKuYX2obN2X3Jz7t19PYCMA", img:"pic_04.png"
        },
        {
            title:"凱琪", 
            url:"https://www.twitch.tv/aphrolin1107", img:"pic_05.png"
        },
        {
            title:"西區", 
            url:"https://www.facebook.com/Cqi-%E8%A5%BF%E5%8D%80-1857651841197281", img:"pic_07.png"
        },
        {
            title:"尼亞斯", 
            url:"https://www.youtube.com/channel/UCoQWUg6Sdv0-aSbaR-L1ZFw", img:"pic_08.png"
        },
    ]
    return (
        <>
          {/* <!--直播活動--> */}
        <section className="event_03">
            <div className="inner_wrap wow fadeInUp">
                <h2>官方直播主頻道 現在就開啟直播提醒，準時鎖定節目</h2>
                {/* <!--影片框--> */}
                <div className="event_live_wrap">
                    <div className="live_video-container">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/7Jk7Znqe73U" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                </div>
                {/* <!--直播主照片輪播--> */}
                <div className="kol">
                    <h3>參與嘉賓 點擊實況主圖片・可觀看該實況主頻道視角</h3>
                    <div className="pic_wrap">
                        {kols.map((kol,index) => 
                            <div key={`div-kol-${index}`}>
                            <a href={kol.url} target="_blank" rel="noreferrer" title={kol.title}><img src={`/events/img/${kol.img}`} alt={kol.title} /></a>
                        </div>
                            )}
                        
                        
                    </div>
                </div>
            </div>
            <div className="bg_bottom"></div>
        </section>
        </>
    )
}

export default Section3